import {createContext} from 'react'
import {TranslateStore} from './TranslateStore';

export const storeContext = createContext({
    translateStore: new TranslateStore
});
